
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.023 3.215a.637.637 0 00-.943 0l-3.775 4.03.944 1.009 3.774-4.038a.751.751 0 000-1zm2.838-.007l-6.612 7.06L5.92 7.79a.637.637 0 00-.943 0 .746.746 0 000 1.008l2.797 2.987a.637.637 0 00.943 0l7.087-7.561a.746.746 0 000-1.008h-.006a.624.624 0 00-.937-.007zM1.196 8.804l2.797 2.987a.637.637 0 00.944 0l.468-.5-3.266-3.502a.637.637 0 00-.943 0 .755.755 0 000 1.015z","fill":"#515952"}})])
          )
        }
      }
    